import styled from 'styled-components';

interface FlightStageContainerProps {
  $hasLegend: boolean;
}

export const FlightStageContainer = styled.div<FlightStageContainerProps>`
  ${props =>
    props.$hasLegend
      ? `
    position: absolute;
    bottom: 55px;
    left: 0;
    right: 0;
    z-index: 10;
    padding: 0 0 0 48px;
  `
      : `
    position: relative;
    padding: 0 0 0 60px;
    margin-top: -5px;
  `}
`;

export const FlightStageLoadingContainer = styled.div<FlightStageContainerProps>`
  ${props =>
    props.$hasLegend
      ? `
    position: absolute;
    bottom: 44px;
    left: 0;
    right: 0;
    z-index: 10;
    padding: 0 0 0 48px;
  `
      : `
    position: relative;
    padding: 0 0 0 60px;
    margin-top: -5px;
  `}
`;

interface FlightStageGridProps {
  $totalColumns: number;
}

export const FlightStageGrid = styled.div<FlightStageGridProps>`
  display: grid;
  grid-template-columns: repeat(${props => props.$totalColumns}, 1fr);
  width: 100%;
  gap: 2px;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 4px;
  padding: 8px;
`;

interface FlightStageColumnProps {
  $gridColumnStart: number;
  $gridColumnEnd: number;
}

export const FlightStageColumn = styled.div<FlightStageColumnProps>`
  grid-column-start: ${props => props.$gridColumnStart};
  grid-column-end: ${props => props.$gridColumnEnd};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const FlightStageLoading = styled.div`
  grid-column: 1 / -1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
  margin-top: 5px;
  font-size: 12px;
  color: #666;
  gap: 8px;
`;

export const FlightStageEmpty = styled.div`
  grid-column: 1 / -1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
  margin-top: 5px;
  font-size: 12px;
  color: #666;
  gap: 6px;
`;
